import * as actionTypes from './actionTypes'
import appraisalAxios from '../../axios/appraisal'
import { enqueueSnackbar } from './alert'
import { saveFileFromResponse } from '../../helpers/utils'
import baseAxios from '../../axios/base'

export const fetchAppraisalData = (filterOptions, appraisalType) => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page || 1 : 1,
      perPage: filterOptions ? filterOptions.perPage || 10 : 10
    }
    dispatch(fetchAppraisalDataStart())
    appraisalAxios
      .get(appraisalType, {
        params
      })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: +per_page,
            from,
            to,
            total
          }

          dispatch(setAppraisalFilter(filterOptions ?? {}))
          dispatch(fetchAppraisalDataSuccess(pagination, data, appraisalType))
          if (filterOptions) {
            dispatch(
              fetchToStage(
                filterOptions.status_id,
                filterOptions.structure_id,
                'appraisal',
                filterOptions
              )
            )
          }
        }
      })
      .catch(error => {
        dispatch(fetchAppraisalDataFailed(error))
        dispatch(
          enqueueSnackbar({
            message: 'Fetch Appraisal Data Error',
            options: {
              variant: 'error'
            }
          })
        )
      })
  }
}

export const fetchAppraisalDataStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_DATA_START
  }
}

export const fetchAppraisalDataSuccess = (pagination, records, appraisalType) => {
  return {
    type: actionTypes.FETCH_APPRAISAL_DATA_SUCCESS,
    pagination,
    records,
    appraisalType
  }
}

export const fetchAppraisalDataFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_APPRAISAL_DATA_FAILED,
    errorMessage
  }
}

export const setAppraisalFilter = filterOptions => {
  return {
    type: actionTypes.SET_APPRAISAL_FILTER,
    filterOptions
  }
}

export const fetchAppraisalResultData = resultId => {
  return dispatch => {
    dispatch(fetchAppraisalResultDataStart())
    appraisalAxios
      .get(`${resultId}`)
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const responseData = response.data.data

          const { result_structure, ...appraisalInfo } = responseData

          dispatch(fetchAppraisalResultDataSuccess(result_structure, appraisalInfo))
        }
      })
      .catch(error => {
        dispatch(fetchAppraisalResultDataFailed(error))
        dispatch(
          enqueueSnackbar({
            message: 'Fetch Appraisal Data Error',
            options: {
              variant: 'error'
            }
          })
        )
      })
  }
}

const fetchAppraisalResultDataStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_RESULT_START
  }
}

const fetchAppraisalResultDataSuccess = (appraisalData, appraisalInfo) => {
  return {
    type: actionTypes.FETCH_APPRAISAL_RESULT_SUCCESS,
    appraisalData,
    appraisalInfo
  }
}

const fetchAppraisalResultDataFailed = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_RESULT_FAILED
  }
}

export const saveAppraisal = appraisalData => {
  return dispatch => {
    dispatch(saveAppraisalStart())
    appraisalAxios
      .patch(`${appraisalData.result_id}`, appraisalData)
      .then(response => {
        if (response?.status === 200) {
          // dispatch(fetchAppraisalResultData(appraisalData?.result_id))
          dispatch(saveAppraisalSuccess(appraisalData?.result_structure[0]?.result_structure_id))
          dispatch(
            enqueueSnackbar({
              message: 'Apprisal Saved',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(error => {
        dispatch(saveAppraisalFailed())
        dispatch(
          enqueueSnackbar({
            message: error?.response?.data?.message || 'Save Appraisal Error',
            options: {
              variant: 'error'
            }
          })
        )
      })
  }
}

const saveAppraisalStart = () => {
  return {
    type: actionTypes.APPRAISAL_SAVE_START
  }
}

const saveAppraisalSuccess = structureId => {
  return {
    type: actionTypes.APPRAISAL_SAVE_SUCCESS,
    structureId
  }
}

const saveAppraisalFailed = () => {
  return {
    type: actionTypes.APPRAISAL_SAVE_FAILED
  }
}

export const calculateAppraisal = data => {
  return dispatch => {
    dispatch(fetchAppraisalResultDataStart())
    baseAxios
      .post('calculate/recalculate/result_header', data)
      .then(response => {
        if (response?.status === 200) {
          const responseData = response.data

          const { result_structure, ...appraisalInfo } = responseData

          dispatch(fetchAppraisalResultDataSuccess(result_structure, appraisalInfo))
          dispatch(
            enqueueSnackbar({
              message: 'Calculate Success',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(error => {
        dispatch(fetchAppraisalResultDataFailed(error))
        dispatch(
          enqueueSnackbar({
            message: 'Calculate Error',
            options: {
              variant: 'error'
            }
          })
        )
      })
  }
}

export const clearFilteredAppraisalRecords = () => {
  return {
    type: actionTypes.CLEAR_FILTERED_APPRAISAL_RECORDS
  }
}

export const fetchAppraisalComments = (id, type) => {
  return dispatch => {
    let requestPath = ''

    if (!id) return
    if (type === 'STT01') {
      requestPath = 'kpi_comment'
    } else if (type === 'STT02') {
      requestPath = 'competency_comment'
    }
    if (requestPath) {
      dispatch(fetchAppraisalCommentsStart())
      baseAxios
        .get(`${requestPath}/${id}`)
        .then(response => {
          if (response.status === 200) {
            dispatch(fetchAppraisalCommentsSuccess(response.data.data))
          }
        })
        .catch(error => {
          dispatch(fetchAppraisalCommentsFailed(error))
        })
    }
  }
}

export const fetchAppraisalCommentsStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_COMMENT_START
  }
}

export const fetchAppraisalCommentsSuccess = comments => {
  return {
    type: actionTypes.FETCH_APPRAISAL_COMMENT_SUCCESS,
    comments
  }
}

export const fetchAppraisalCommentsFailed = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_COMMENT_FAILED
  }
}

export const postAppraisalComments = (id, type, commentMessage, commentFile) => {
  return dispatch => {
    let requestPath = ''
    if (!id) return
    if (type === 'STT01') {
      requestPath = 'kpi_comment'
    } else if (type === 'STT02') {
      requestPath = 'competency_comment'
    }
    if (requestPath) {
      let formData = new FormData()
      formData.append('id', id)
      formData.append('commentFile', commentFile)
      formData.append('commentMessage', commentMessage)
      dispatch(postAppraisalCommentsStart())
      baseAxios
        .post(`${requestPath}`, formData, {
          enctype: 'multipart/form-data'
        })
        .then(response => {
          if (response.status === 201) {
            dispatch(fetchAppraisalComments(id, type))
            dispatch(postAppraisalCommentsSuccess(response.data.data))
          }
        })
        .catch(error => {
          dispatch(postAppraisalCommentsFailed(error))
        })
    }
  }
}

export const postAppraisalCommentsStart = () => {
  return {
    type: actionTypes.POST_APPRAISAL_COMMENT_START
  }
}

export const postAppraisalCommentsSuccess = comment => {
  return {
    type: actionTypes.POST_APPRAISAL_COMMENT_SUCCESS,
    comment
  }
}

export const postAppraisalCommentsFailed = () => {
  return {
    type: actionTypes.POST_APPRAISAL_COMMENT_FAILED
  }
}

export const deleteAppraisalComment = (kpiId, commentId, type) => {
  return dispatch => {
    let requestPath = ''
    if (!commentId || !kpiId) return
    if (type === 'STT01') {
      requestPath = 'kpi_comment'
    } else if (type === 'STT02') {
      requestPath = 'competency_comment'
    }
    if (requestPath) {
      baseAxios
        .delete(`${requestPath}/${commentId}`)
        .then(response => {
          if (response.status === 204) {
            dispatch(fetchAppraisalComments(kpiId, type))
            dispatch(deleteAppraisalCommentSuccess())
          }
        })
        .catch(error => {
          dispatch(
            enqueueSnackbar({
              message: 'Delete Comment Error',
              options: {
                variant: 'error'
              }
            })
          )
          dispatch(deleteAppraisalCommentFailed(error))
        })
    }
  }
}

export const deleteAppraisalCommentStart = () => {
  return {
    type: actionTypes.DELETE_APPRAISAL_COMMENT_START
  }
}

export const deleteAppraisalCommentSuccess = () => {
  return {
    type: actionTypes.DELETE_APPRAISAL_COMMENT_SUCCESS
  }
}

export const deleteAppraisalCommentFailed = () => {
  return {
    type: actionTypes.DELETE_APPRAISAL_COMMENT_FAILED
  }
}

export const downloadCommentAttachment = (id, type) => {
  return dispatch => {
    let requestPath = ''
    if (!id) return
    if (type === 'STT01') {
      requestPath = 'kpi_comment'
    } else if (type === 'STT02') {
      requestPath = 'competency_comment'
    }
    if (requestPath) {
      baseAxios
        .get(`${requestPath}/file/${id}`, { responseType: 'blob' })
        .then(response => {
          if (response.status === 200) {
            // dispatch(fetchAppraisalComments(id, type))
            saveFileFromResponse(response)
          }
        })
        .catch(error => {})
    }
  }
}

export const clearSelectedAppraisalData = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_APPRAISAL_DATA
  }
}

/// เผื่อใช้

export const importAppraisalData = (importFile, filterOptions, appraisalType) => {
  return dispatch => {
    dispatch(importAppraisalStart())
    let formData = new FormData()
    formData.append('file', importFile)

    appraisalAxios
      .post('/import', formData)
      .then(response => {
        if (response.status === 200) {
          dispatch(importAppraisalSuccess(response.data))
          dispatch(
            enqueueSnackbar({
              message: 'Appraisal Data Imported',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(fetchAppraisalData(filterOptions, appraisalType))
        }
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: error.response.data.message,
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(importAppraisalFailed(error))
      })
  }
}

const importAppraisalStart = () => {
  return {
    type: actionTypes.IMPORT_APPRAISAL_START
  }
}

const importAppraisalSuccess = () => {
  return {
    type: actionTypes.IMPORT_APPRAISAL_SUCCESS
  }
}

const importAppraisalFailed = () => {
  return {
    type: actionTypes.IMPORT_APPRAISAL_FAILED
  }
}

export const exportAppraisalData = filterOptions => {
  return dispatch => {
    dispatch(exportAppraisalDataStart())
    let params = null
    if (filterOptions) {
      params = filterOptions
    }
    appraisalAxios
      .get('/export', {
        params,
        responseType: 'blob'
      })
      .then(response => {
        if (response.status === 200) {
          saveFileFromResponse(response)
          dispatch(exportAppraisalDataSuccess())
          dispatch(
            enqueueSnackbar({
              message: 'Appraisal Exported',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(error => {
        dispatch(exportAppraisalDataFailed(error))
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Appraisal field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: '',
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
      })
  }
}

export const exportAppraisalDataStart = () => {
  return {
    type: actionTypes.EXPORT_APPRAISAL_START
  }
}

export const exportAppraisalDataSuccess = () => {
  return {
    type: actionTypes.EXPORT_APPRAISAL_SUCCESS
  }
}

export const exportAppraisalDataFailed = errorMessage => {
  return {
    type: actionTypes.EXPORT_APPRAISAL_FAILED,
    errorMessage
  }
}

export const fetchToStage = (statusId, structureId, fromPage, filterOptions) => {
  return dispatch => {
    if (statusId && structureId && fromPage) {
      dispatch(fetchToStageStart())
      baseAxios
        .get(`stage/to_stage/${statusId}`, {
          params: {
            ...filterOptions,
            structure_id: structureId,
            from_page: fromPage
          }
        })
        .then(response => {
          if (response.status === 200) {
            dispatch(fetchToStageSuccess(response.data.data))
          }
        })
        .catch(err => {
          dispatch(fetchToStageFailed())
          dispatch(
            enqueueSnackbar({
              message: 'Fetch Action To Stage Error',
              options: {
                variant: 'error'
              }
            })
          )
        })
    }
  }
}

const fetchToStageStart = () => {
  return {
    type: actionTypes.FETCH_TO_STAGE_START
  }
}

const fetchToStageSuccess = toStageList => {
  return {
    type: actionTypes.FETCH_TO_STAGE_SUCCESS,
    toStageList
  }
}

const fetchToStageFailed = () => {
  return {
    type: actionTypes.FETCH_TO_STAGE_FAILED
  }
}

export const bulkUpdateAppraisal = (data, filterOptions) => {
  return dispatch => {
    dispatch(bulkUpdateAppraisalStart())
    appraisalAxios
      .post('/approve', data)
      .then(response => {
        if (response.status === 200) {
          dispatch(bulkUpdateAppraisalSuccess())
          dispatch(fetchAppraisalData(filterOptions))
        }
      })
      .catch(error => {
        dispatch(bulkUpdateAppraisalFailed())
      })
  }
}

const bulkUpdateAppraisalStart = () => {
  return {
    type: actionTypes.BULK_UPDATE_APPRAISAL_START
  }
}

const bulkUpdateAppraisalSuccess = () => {
  return {
    type: actionTypes.BULK_UPDATE_APPRAISAL_SUCCESS
  }
}

const bulkUpdateAppraisalFailed = () => {
  return {
    type: actionTypes.BULK_UPDATE_APPRAISAL_FAILED
  }
}

export const saveActionTo = (data, resultId) => {
  return dispatch => {
    dispatch(saveActionToStart())
    appraisalAxios
      .patch(`/action2/${resultId}`, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(saveActionToSuccess())
          dispatch(fetchAppraisalResultData(resultId))
          dispatch(
            enqueueSnackbar({
              message: 'Save Action Success',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(error => {
        dispatch(saveActionToFailed())
        dispatch(
          enqueueSnackbar({
            message: 'Save Action To Failed',
            options: {
              variant: 'error'
            }
          })
        )
      })
  }
}
const saveActionToStart = () => {
  return {
    type: actionTypes.SAVE_ACTION_TO_START
  }
}

const saveActionToSuccess = () => {
  return {
    type: actionTypes.SAVE_ACTION_TO_SUCCESS
  }
}

const saveActionToFailed = () => {
  return {
    type: actionTypes.SAVE_ACTION_TO_FAILED
  }
}

export const fetchActionPlan = recordData => {
  return dispatch => {
    dispatch(fetchActionPlanStart())
    baseAxios
      .get('/action_plan', { params: recordData })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchActionPlanSuccess(response.data))
        }
      })
      .catch(error => {
        dispatch(fetchActionPlanFailed(error))
        dispatch(
          enqueueSnackbar({
            message: 'Fetch Action Plan Error',
            options: {
              variant: 'error'
            }
          })
        )
      })
  }
}

export const fetchActionPlanStart = () => {
  return {
    type: actionTypes.FETCH_ACTION_PLAN_START
  }
}

export const fetchActionPlanSuccess = data => {
  return {
    type: actionTypes.FETCH_ACTION_PLAN_SUCCESS,
    data
  }
}

export const fetchActionPlanFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ACTION_PLAN_FAILED,
    errorMessage
  }
}

export const saveActionPlan = data => {
  return dispatch => {
    dispatch(saveActionPlanStart())
    baseAxios
      .patch('/action_plan', data)
      .then(response => {
        if (response.status === 200) {
          dispatch(saveActionPlanSuccess())
          dispatch(
            enqueueSnackbar({
              message: 'Save Action Plan Success',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(error => {
        dispatch(saveActionPlanFailed())
        dispatch(
          enqueueSnackbar({
            message: 'Save Action Plan To Failed',
            options: {
              variant: 'error'
            }
          })
        )
      })
  }
}
const saveActionPlanStart = () => {
  return {
    type: actionTypes.SAVE_ACTION_PLAN_START
  }
}

const saveActionPlanSuccess = () => {
  return {
    type: actionTypes.SAVE_ACTION_PLAN_SUCCESS
  }
}

const saveActionPlanFailed = () => {
  return {
    type: actionTypes.SAVE_ACTION_PLAN_FAILED
  }
}

export const sumUp = payload => {
  return dispatch => {
    dispatch(sumUpStart())
    appraisalAxios
      .get('sum_up', {
        params: payload
      })
      .then(response => {
        if (response.status === 200) {
          // const responseData = response.data.data

          // const { result_structure, ...appraisalInfo } = responseData

          dispatch(sumUpSuccess())
          dispatch(fetchAppraisalResultData(payload.result_id))
        }
      })
      .catch(err => {
        console.log(err, { ...err })
        dispatch(sumUpFailed())
      })
  }
}

const sumUpStart = () => {
  return {
    type: actionTypes.APPRAISAL_SUM_UP_START
  }
}

const sumUpSuccess = () => {
  return {
    type: actionTypes.APPRAISAL_SUM_UP_SUCCESS
  }
}

const sumUpFailed = () => {
  return {
    type: actionTypes.APPRAISAL_SUM_UP_FAILED
  }
}
